jQuery(function($) {

 /* VAR */

     var header = $("#masthead");
     var h_header = $("#masthead").height();
     $(window).scroll(function () {
        
                action_on_scroll();

        });
 function action_on_scroll(){

        
            var l_window = parseInt($(window).width());
            
    
            if (l_window > 800){
                if ($(window).scrollTop() > 30){
                    header.addClass("fixed_scrol");
                }else{
                    header.removeClass("fixed_scrol");
                }

            }else{

                if ($(window).scrollTop() > 0){
                    header.addClass("fixed_scrol_mobile");
                }else{
                    header.removeClass("fixed_scrol_mobile");
                }

            }

     }


     action_on_scroll();


     /* *****************  */
    /* NICESELECT POUR VARIATION DANS SINGLE PRODUCT + LES FITRES DANS LES PAGES D'ARCHIVES
  /* *****************  */
   var $variations = $('.variations select').niceSelect();
   $('.variations select').on('change', function() {
    $variations.niceSelect('update');
   // document.location=this.value;
  });


    /*****************************************************************/
      /************ FORULAIRE DE RECHERCHE DES ACTIVITES / ACTIONS ******************/
      /*****************************************************************/

    $('#recherche_produit button.blockFilterAction-title').on('click',function(){
         return false;
    });

   $("#recherche_produit input[type='checkbox']").on('change',function(){
        $('#main-page').addClass('loader');
        $('#recherche_produit').submit();
    });

   $( ".js-filter-item" ).each(function( index ) {
     var cores = $(this).data('slug');
     var get_corres_checkbox = $('#lateral_page input[value="'+cores+'"]').data('string');
     $(this).text(get_corres_checkbox);
   });

   $('.js-filter-item').on('click',function(){
       var cores = $(this).data('slug');
       $('#lateral_page input[value="'+cores+'"]').prop("checked", false);
       $('#main-page').addClass('loader');
       $('#recherche_produit').submit();
    });

   $('.js-keyword-filter').on('click',function(){
      $('input#mots_cles').val('');
      $('#main-page').addClass('loader');
      $('#recherche_produit').submit();
    });


   /*********************************/
  /** TABS EN MODE MOBILE + ACCORDEON SIMPLE, PAR EXEMPLE FILTRE SUR PAGE "NOS PRODUITS" **/
  /*********************************/

  /* if in drawer mode */
  $(".js-Tabs-Inner-Title").click(function() {
       var parentActiveTab = $(this).attr('data-tabs-group');

      if($(this).next().css('display') == 'none'){
          $(parentActiveTab+" .js-Tabs-Inner-Content").hide();
          var d_activeTab = $(this).attr("rel"); 
          $("#"+d_activeTab).slideDown(300);
          $(this).addClass('d_active');
        
        $(parentActiveTab+" .js-Tabs-Inner-Title").removeClass("d_active");
          $(this).addClass("d_active");
        
       //$(parentActiveTab+" .Tabs-Liste li").removeClass("active"); // inutile pour footer mais utile pour global tabs
       // $(parentActiveTab+" .Tabs-Liste li[rel^='"+d_activeTab+"']").addClass("active");  // inutile pour footer mais utile pour global tabs
    }else{
      $(this).next().slideUp(400);
      $(this).removeClass("d_active");
      $(parentActiveTab+" .js-Tabs-Inner-Title").removeClass("d_active");  // inutile pour footer mais utile pour global tabs
    }
    });

  $(".blockFilterAction.see_it .js-Tabs-Inner-Title").addClass('d_active');


  $('.woocommerce-form-login').prev().addClass('centerh2');

  //   /* Niceselect en mode archive produit */
  var $select_archive_product = $('.orderby').addClass('archive-product-select').niceSelect();

  // // niceselect pour les cats 
  //  $('.to_nicedropdowncat-js').niceSelect();

  //   $('.ActionToChild-js').on('change', function() {
  //     document.location=this.value;
  //   });

    //  $('.check_').on('change', function() {
    //   $(this).closest('form').trigger('submit');
    // });




    /* Simple gallery dans les pages flexibles */
     $('.gallery_js').slick({
      arrows: false,
      autoplay:true,
      autoplaySpeed: 3000,
      slidesToScroll: 1,
      slidesToShow: 1,
      dots:true,
      pauseOnFocus:false,
      pauseOnHover:false,
    });



     /* On ajoute PLUS et MOINS pour la quantité !! */

     //https://www.divi-community.fr/en/tutoriels-divi/modifier-style-selecteur-quantite-woocommerce-divi/
//    function PbStyleQuantite(a) {
//     var b, c = !1;
//     a || (a = ".qty"),
//     b = jQuery("div.quantity:not(.buttons_added), td.quantity:not(.buttons_added)").find(a),
//     b.length && (jQuery.each(b, function(a, b) {
//         "date" !== jQuery(b).prop("type") && "hidden" !== jQuery(b).prop("type") && (jQuery(b).parent().hasClass("buttons_added") || (jQuery(b).parent().addClass("buttons_added").prepend('<button class="minus" type="button" value="-"><span class="icon-less"></span></button>'),
//         jQuery(b).addClass("input-text").after('<button type="button" value="+" class="plus"><span class="icon-plus"></span></button>'),
//         c = !0));
//     }),
//     c && (jQuery("input" + a + ":not(.product-quantity input" + a + ")").each(function() {
//         var a = parseFloat(jQuery(this).attr("min"));
//         a && a > 0 && parseFloat(jQuery(this).val()) < a && jQuery(this).val(a);
//     }),
//     jQuery(".plus, .minus").unbind("click"),
//     jQuery(".plus, .minus").on("click", function() {
//         var b = jQuery(this).parent().find(a)
//           , c = parseFloat(b.val())
//           , d = parseFloat(b.attr("max"))
//           , e = parseFloat(b.attr("min"))
//           , f = b.attr("step");
//         c && "" !== c && "NaN" !== c || (c = 0),
//         "" !== d && "NaN" !== d || (d = ""),
//         "" !== e && "NaN" !== e || (e = 0),
//         "any" !== f && "" !== f && void 0 !== f && "NaN" !== parseFloat(f) || (f = 1),
//         jQuery(this).is(".plus") ? d && (d == c || c > d) ? b.val(d) : b.val(c + parseFloat(f)) : e && (e == c || c < e) ? b.val(e) : c > 0 && b.val(c - parseFloat(f)),
//         b.trigger("change");
//     })));
// }
// jQuery(window).on("load", function() {
//     PbStyleQuantite();
// });
// jQuery(document).ajaxComplete(function() {
//     PbStyleQuantite();
// });

     function addButtonListeners(input, minusBtn, plusBtn) {
  minusBtn.on("click", function() {
    var val = parseFloat(input.val());
    if (val > parseFloat(input.attr("min"))) {
      input.val(val - parseFloat(input.attr("step"))).change();
    }
  });

  plusBtn.on("click", function() {
    var max = input.attr("max") ? parseFloat(input.attr("max")) : 1000;   
    var val = parseFloat(input.val());
    if (val < max) {
      input.val(val + parseFloat(input.attr("step"))).change();
    }
  });
}

function PbStyleQuantite() {
  var inputs = jQuery("div.quantity:not(.buttons_added) input[type='number'], td.quantity:not(.buttons_added) input[type='number']");

  inputs.each(function() {
    var input = jQuery(this);
    var minusBtn = jQuery('<button type="button" class="minus"><span class="icon-less"></span></button>');
    var plusBtn = jQuery('<button type="button" class="plus"><span class="icon-plus"></span></button>');
    var wrapper = jQuery('<div class="quantity buttons_added"></div>');

    addButtonListeners(input, minusBtn, plusBtn);

    input.addClass("input-text");
    wrapper.insertBefore(input);
    input.appendTo(wrapper);
    minusBtn.appendTo(wrapper);
    plusBtn.appendTo(wrapper);
  });
}

jQuery(function() {
  PbStyleQuantite();
});

jQuery(document).ajaxComplete(function() {
  PbStyleQuantite();
});
   
});




